import { Organization } from "generated/graphql";
import { ClientApp } from "models";
import React, { PureComponent } from "react";
import { RouteComponentProps } from "react-router-dom";
import { BreadcrumbItem as BreadcrumbsComponentItem, Breadcrumbs as BreadcrumbsComponent } from "@xapp/components";
import { pathToDynamicParams, urlToBreadcrumbs } from "../utils";

export interface BreadcrumbItem {
    label: string;
    path?: string;
}

export interface DynamicParam {
    index: number;
    stateRef: string;
}

export interface BreadcrumbsDispatchProps { }
export interface BreadcrumbsOwnProps extends RouteComponentProps<any> { }
export interface BreadcrumbsStateProps {
    app?: ClientApp;
    organization?: Organization;
}

export interface BreadcrumbsState {
    app?: ClientApp;
    breadcrumbs: BreadcrumbItem[];
    dynamicParams: {
        [key: string]: DynamicParam;
    };
    organization?: Organization;
}

export type BreadcrumbsProps = BreadcrumbsDispatchProps & BreadcrumbsOwnProps & BreadcrumbsStateProps;

export class Breadcrumbs extends PureComponent<BreadcrumbsProps, BreadcrumbsState> {
    constructor(props: BreadcrumbsProps) {
        super(props);

        this.state = {
            app: props.app,
            // initially, base the breadcrumbs off of the URL from react-router
            breadcrumbs: urlToBreadcrumbs(props.match.url),
            // grab the dynamic params off of the path from react-router and identify
            // the array indices of where they are stored in the breadcrumbs array
            dynamicParams: pathToDynamicParams(props.match.path, props.match.params),
            organization: props.organization
        };
    }

    componentDidMount() {
        const { breadcrumbs, dynamicParams } = this.state;

        this.dynamicParamsToBreadcrumbs(dynamicParams, breadcrumbs);
    }

    componentWillReceiveProps(newProps: BreadcrumbsProps) {
        const { breadcrumbs, dynamicParams } = this.state;

        this.setState(
            {
                app: newProps.app,
                organization: newProps.organization
            },
            () => {
                this.dynamicParamsToBreadcrumbs(dynamicParams, breadcrumbs);
            }
        );
    }

    /**
     * Replaces the slug label with the model name
     * @param dynamicParams
     * @param breadcrumbs
     */
    dynamicParamsToBreadcrumbs(dynamicParams: any, breadcrumbs: BreadcrumbItem[]) {
        const { app, organization } = this.state;

        const newBreadcrumbs = breadcrumbs.slice();

        // currently, the only dynamically derived route params are app, intent, & organization
        // if that changes, this will need to be updated
        if (Object.keys(dynamicParams).length !== 0) {
            if (dynamicParams.app && app) {
                newBreadcrumbs[dynamicParams.app.index].label = app.name;
            }

            if (dynamicParams.organization && organization) {
                newBreadcrumbs[dynamicParams.organization.index].label = organization.name;
            }
        }

        this.setState({ breadcrumbs: newBreadcrumbs });
    }

    render() {
        const items = this.state.breadcrumbs.map<BreadcrumbsComponentItem>(item => ({
            label: item.label,
            url: item.path
        }));
        return (
            <BreadcrumbsComponent
                items={items}
            />
        );
    }
}
